import axios from '@/axios';

const RESOURCE_NAME = '/ecosystem/dashboard';

export default {
    getOnboardingStep() {
        return axios.get(`${RESOURCE_NAME}/get-onboarding-step`)
    },

    saveOnboardingStep(step) {
        return axios.post(`${RESOURCE_NAME}/save-onboarding-step`, {step})
    },

    getAddedStartupsCount() {
        return axios.get(`${RESOURCE_NAME}/get-added-startups-count`)
    },

    getAppliedStartupsCount() {
        return axios.get(`${RESOURCE_NAME}/get-applied-startups-count`)
    },

    getEnterprisesCount() {
        return axios.get(`${RESOURCE_NAME}/get-enterprises-count`)
    },

    getRecentlyAddedStartups() {
        return axios.get(`${RESOURCE_NAME}/get-recently-added-startups`)
    },

    getNeedsSolutionsNumbers() {
        return axios.get(`${RESOURCE_NAME}/get-needs-solutions-numbers`)
    },

    getActivities() {
        return axios.get(`${RESOURCE_NAME}/get-activities`);
    },

    getNeedsList(type, filters) {
        return axios.post(`${RESOURCE_NAME}/get-needs-list?type=${type}`, {filters});
    },

    getNeedsCategories(type) {
        return axios.get(`${RESOURCE_NAME}/get-needs-categories?type=${type}`);
    },
}
